import { render } from "./AdminHome.vue?vue&type=template&id=a9baffac&scoped=true"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"

import "./AdminHome.vue?vue&type=style&index=0&id=a9baffac&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9baffac"]])

export default __exports__